var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShareScreenFull(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 80 45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "svg-share-screen-full-a",
    d: "m4 12 1.41 1.41L11 7.83V20h2V7.83l5.58 5.59L20 12l-8-8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg-share-screen-full-c",
    d: "M0 0h50v50H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 78,
    height: 43,
    x: 1,
    y: 1,
    stroke: "var(--svg-bg-color)",
    strokeOpacity: "var(--svg-bg-opacity)",
    strokeWidth: 2,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 37,
    x: 4,
    y: 4,
    fill: "currentColor",
    rx: 2
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(28 10)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "svg-share-screen-full-b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#svg-share-screen-full-a"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#svg-share-screen-full-b)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#svg-share-screen-full-c",
    fill: "var(--svg-arrow-color)",
    transform: "translate(-13 -13)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareScreenFull);
export default __webpack_public_path__ + "static/media/share-screen-full.47af87bf09e915e47e46ae8be265087a.svg";
export { ForwardRef as ReactComponent };